<template>
  <Teleport to="body">
    <div class="toast-container">
      <div v-if="visible" class="toast" :class="[type, { 'show': visible }]">
        <div class="toast-header">
          <h3>{{ type === 'success' ? 'Sucesso' : type === 'error' ? 'Erro' : 'Aviso' }}</h3>
          <button @click="close">&times;</button>
        </div>
        <div class="toast-body">
          {{ message }}
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, ref, watch } from 'vue';
import { toastStore } from '@/store/toastStore';

const store = toastStore();
const visible = ref(false);
const message = ref('');
const type = ref('info');
let timeoutId = null;

const close = () => {
  visible.value = false;
};

watch(() => store.toastId, () => {
  if (store.toastMessage) {
    message.value = store.toastMessage;
    type.value = store.toastType;
    visible.value = true;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      close();
      store.clear();
      timeoutId = null;
    }, 5000);
  }
});

onBeforeUnmount(() => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});
</script>

<style scoped>
/* Estilos movidos para main.scss para consistência global */
</style>